<template>
    <div>
        <helpinfo :helpData="helpData"
                  style="background-color: #fff;">
            <div slot="slotR">
                <Dropdown class="org"
                          trigger="click">
                    <span style="cursor: pointer;">{{orgNames[orgId] || '全部'}}
                        <Icon type="ios-arrow-down"></Icon>
                    </span>
                    <DropdownMenu slot="list"
                                  style="padding: 0 15px;">
                        <Input v-model="orgInput"
                               @on-change="searchOrgTree"
                               :placeholder="$t('请输入关键词')" />
                        <div class="org-pack">
                            <Tree v-show="orgTree.length"
                                  :data="orgTree"
                                  @on-select-change="orgChange"></Tree>
                        </div>
                    </DropdownMenu>
                </Dropdown>
            </div>
        </helpinfo>
        <div class="ope-sta">
            <div class="item-more">
                <div class="card-pack"
                     style="width: 26%">
                    <div class="title">{{$t('待办事项')}}</div>
                    <ul class="recharge-list order-pack">
                        <li class='summary'>
                            <span>{{$t('待审批')}}</span>
                        </li>
                        <li>
                            <span>{{$t('用户')}}</span>
                            <span>0</span>
                        </li>
                        <li>
                            <span>{{$t('服务开通')}}</span>
                            <span>0</span>
                        </li>
                        <li class='summary'>
                            <span>{{$t('工单')}}</span>
                        </li>
                        <li>
                            <span>{{$t('待处理')}}</span>
                            <span>0</span>
                        </li>
                        <li>
                            <span>{{$t('处理中')}}</span>
                            <span>0</span>
                        </li>
                    </ul>
                </div>
                <div class="card-pack"
                     style="width: 32.5%">
                    <div class="title">{{$t('费用信息')}}</div>
                    <ul class="bill-list order-pack">
                        <li>
                            <b>{{$money(inf.bill.totalBillAmount,5)}}</b>
                            <span>{{$t('累计出账')}}</span>
                        </li>
                        <li>
                            <b>{{$money(inf.bill.currentBillAmount,5)}}</b>
                            <span>{{$t('本月出账')}}</span>
                        </li>
                        <li>
                            <b>{{$money(inf.bill.invoiceAmount,5)}}</b>
                            <span>{{$t('已开票')}}</span>
                        </li>
                        <li>
                            <b>{{$money(inf.recharge.totalAmount,5)}}</b>
                            <span>{{$t('累计充值')}}</span>
                        </li>
                        <li>
                            <b>{{$money(0,5)}}</b>
                            <span>{{$t('累计在线充值')}}</span>
                        </li>
                        <li>
                            <b>{{$money(inf.recharge.currentMonthAmount,5)}}</b>
                            <span>{{$t('本月充值')}}</span>
                        </li>
                    </ul>
                </div>
                <div class="card-pack"
                     style="width: 39%">
                    <div class="title">{{$t('订单信息')}}</div>
                    <ul class="order-pack">
                        <li>
                            <b>{{inf.order.totalCount || 0}}</b>
                            <span>{{$t('累计已支付订单')}}</span>
                        </li>
                        <li>
                            <b>{{$money(inf.order.totalPayedAmount,5)}}</b>
                            <span>{{$t('金额')}}</span>
                        </li>
                        <li>
                            <b>{{$money(inf.order.totalCouponAmount,5)}}</b>
                            <span>{{$t('优惠券抵扣')}}</span>
                        </li>
                        <li>
                            <b>{{inf.order.currentMonthCount || 0}}</b>
                            <span>{{$t('本月支付订单')}}</span>
                        </li>
                        <li>
                            <b>{{$money(inf.order.currentMonthAmount,5)}}</b>
                            <span>{{$t('金额')}}</span>
                        </li>
                        <li>
                            <b>{{$money(inf.order.currentCouponAmount,5)}}</b>
                            <span>{{$t('优惠券抵扣')}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <consumeTrend :orgId="orgId"></consumeTrend>
            <consumeScatter :data="consume"></consumeScatter>
            <userTop :orgId="orgId"></userTop>
        </div>
    </div>
</template>

<script>
import helpinfo from '@/views/components/basic/helpinfo'
import consumeScatter from './components/consumescatter'
import consumeTrend from './components/consumetrend'
import userTop from './components/usertop'
import API from '@/service/api'

export default {
    name: 'dashboard',
    components: {
        helpinfo,
        consumeScatter,
        consumeTrend,
        userTop
    },
    data () {
        return {
            helpData: {
                modelName: '运营总览'
            },
            inf: {
                recharge: {},
                bill: {},
                order: {}
            },
            consume: [],
            orgInput: null,
            orgTreeStr: '',
            orgTree: [],
            orgNames: {},
            orgId: null

        }
    },
    mounted () {
        this.initInf()
        this.initOrg()
    },
    methods: {
        initInf () {
            this.axios.get(this.urlFormat(API.OPE_STATISTICS), {
                params: { orgId: this.orgId }
            }).then((res) => {
                this.inf = {
                    recharge: res.recharge || {},
                    bill: res.bill || {},
                    order: res.order || {}
                }
                this.consume = res.consume
            })
        },
        initOrg () { // 获取账号的组织树数据
            this.axios.get(this.urlFormat(API.ORGS_WHOLE_ORGS, true)).then(res => {
                if (res.length) {
                    this.orgTree = this.formatOrgData(res)
                    this.orgTreeStr = JSON.stringify(this.orgTree)
                    // this.orgId = res[0].id
                }
            })
        },
        searchOrgTree () { // 组织搜索
            this.orgTree = this.orgInput ? this.trimTree(JSON.parse(this.orgTreeStr), this.orgInput) : JSON.parse(this.orgTreeStr)
        },
        trimTree (data, val) { // 过滤条件
            const orgs = []
            for (const i in data) {
                const item = data[i]
                if (item.children && item.children.length) {
                    item.children = this.trimTree(item.children, val)
                    if (item.children.length || item.title.includes(val)) {
                        orgs.push(item)
                    }
                } else if (item.title.includes(val)) {
                    orgs.push(item)
                }
            }
            return orgs
        },
        formatOrgData (data) {
            const resData = []
            for (const i in data) {
                const item = data[i]
                if (item.id !== '1') {
                    resData.push({
                        title: item.name,
                        expand: true,
                        id: item.id,
                        children: item.children ? this.formatOrgData(item.children) : []
                    })
                }
            }
            return resData
        },
        orgChange (node) {
            this.orgId = node.length ? node[0].id : null
            this.initInf()
        }
    }
}
</script>

<style lang="less" scoped>
.org-pack {
    max-height: 500px;
    overflow: auto;
    line-height: 20px;
    &::-webkit-scrollbar {
        width: 5px;
        height: 1px;
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: #cccccc;
    }
}
.ope-sta {
    padding: 15px;
    .order-pack {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li {
            width: 28%;
            padding-top: 15px;
            span {
                display: block;
                font-size: 12px;
                line-height: 22px;
                color: #808080;
            }
        }
    }

    .item-more {
        display: flex;
        justify-content: space-between;
        height: 170px;
        margin: 0 -7.5px;
        background-position: 8px top;
        .card-pack {
            align-self: stretch;
            margin: 0 7.5px;

            .recharge-list {
                padding: 15px 0 20px;
                li {
                    background: beige;
                    width: 38% !important;
                    margin: 5px 0;
                    padding: 7.5px 5px;

                    &.summary {
                        background: transparent;
                        width: 70px !important;

                        span {
                            padding-left: 0;
                        }
                    }

                    span {
                        display: inline-block;
                        padding-left: 10px;
                        color: #333;
                    }

                    span:last-child {
                        font-weight: bolder;
                    }
                }
            }
        }
        .ul-list {
            display: flex;
            justify-content: space-between;
            padding: 35px 0;
            li {
                position: relative;
                span {
                    display: block;
                    line-height: 40px;
                    color: #808080;
                }
                &:after {
                    content: '';
                    display: inline-block;
                    position: absolute;
                    top: 5px;
                    right: 0;
                    bottom: 18px;
                    border-right: 1px dashed #e9e9e9;
                }
                &:last-child:after {
                    display: none;
                }
            }
            &.recharge-list {
                li {
                    width: 45%;
                    padding-left: 20px;
                }
            }
            &.bill-list {
                li {
                    width: 30%;
                }
            }
        }
    }

    .compute {
        font-size: 12px;
        padding: 14px 0 20px 0;
        border-bottom: 1px dashed #e9e9e9;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .variable {
            min-width: 80px;

            b {
                display: block;
                font-size: 14px;
                margin: 0;
            }

            span {
                color: #808080;
            }
        }

        .symbol {
            width: 26px;
            height: 26px;
            text-align: center;
            line-height: 23px;
            flex-grow: 0;
            border-radius: 50%;
            font-size: 20px;
            box-shadow: 0px 1px 6px rgba(153, 153, 153, 0.46);
        }
    }
}
</style>

<style lang="less">
body .card-pack {
    padding: 10px 15px;
    margin-top: 15px;
    background-color: #fff;

    .title {
        font-size: 12px;
        line-height: 22px;
        font-weight: 600;
        display: flex;
        justify-content: space-between;

        .condition-pack {
            display: flex;
            .item {
                display: inline-block;
                height: 22px;
                line-height: 22px;
                border: 1px solid #e9e9e9;
                color: #333333;
                padding: 0 12px;
                margin-right: 5px;
                border-radius: 11px;
                cursor: pointer;
                &.active,
                &:hover {
                    border-color: #ff6a01;
                    background-color: #ff6a01;
                    color: #fff;
                }
            }
        }
    }
}
</style>
